import React from "react";

const TONES = {
  success: {
    soft: { bg: "var(--kr-status-success-bg)", fg: "var(--kr-status-success-fg)", dot: "var(--kr-success-500)" },
    solid: { bg: "var(--kr-success-500)", fg: "#fff", dot: "#fff" },
  },
  warning: {
    soft: { bg: "var(--kr-status-warning-bg)", fg: "var(--kr-status-warning-fg)", dot: "var(--kr-warning-500)" },
    solid: { bg: "var(--kr-warning-500)", fg: "#fff", dot: "#fff" },
  },
  danger: {
    soft: { bg: "var(--kr-status-danger-bg)", fg: "var(--kr-status-danger-fg)", dot: "var(--kr-danger-500)" },
    solid: { bg: "var(--kr-danger-500)", fg: "#fff", dot: "#fff" },
  },
  info: {
    soft: { bg: "var(--kr-status-info-bg)", fg: "var(--kr-status-info-fg)", dot: "var(--kr-info-500)" },
    solid: { bg: "var(--kr-info-500)", fg: "#fff", dot: "#fff" },
  },
  pending: {
    soft: { bg: "var(--kr-status-pending-bg)", fg: "var(--kr-status-pending-fg)", dot: "var(--kr-pending-500)" },
    solid: { bg: "var(--kr-pending-500)", fg: "#fff", dot: "#fff" },
  },
  neutral: {
    soft: { bg: "var(--kr-status-neutral-bg)", fg: "var(--kr-status-neutral-fg)", dot: "var(--kr-neutral-500)" },
    solid: { bg: "var(--kr-neutral-900)", fg: "#fff", dot: "#fff" },
  },
  brand: {
    soft: { bg: "var(--kr-action-soft-bg)", fg: "var(--kr-action-soft-fg)", dot: "var(--kr-action)" },
    solid: { bg: "var(--kr-action)", fg: "#fff", dot: "#fff" },
  },
};

export function Badge({ tone = "neutral", variant = "soft", dot = false, children, style }) {
  const t = (TONES[tone] || TONES.neutral)[variant] || TONES.neutral.soft;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.4,
        background: t.bg,
        color: t.fg,
        whiteSpace: "nowrap",
        ...(style || {}),
      }}
    >
      {dot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: 999,
            background: t.dot,
            display: "inline-block",
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
}

export default Badge;
